<template>
    <div class="toggle-wrapper">
        <label
                v-if="label"
                class="toggle-label"
                :style="labelStyle"
        >{{ label }}
        </label>
        <label
                :class="[className, {'cursor-not-allowed': disabled}]"
        >
            <input
                type="checkbox"
                class="v-switch-input"
                :name="name"
                :checked="internalState"
                @input="toggle"
                :disabled="disabled"
            >
            <div
                    class="v-switch-core"
                    :style="coreStyle"
            >
                <div
                        class="v-switch-button"
                        :style="buttonStyle"
                >
                    <i
                            class="fas"
                            :class="[icon ? 'fa-' + icon : '' ]"
                            :style="iconStyle"
                    />
                </div>
            </div>

        </label>
    </div>
</template>
<script>
    import {COLORS} from "../helpers/colorVariables";

    const contains = (object, title) =>
        typeof object === 'object' && object.hasOwnProperty(title);
    const px = v => v + 'px';
    const translate3d = (x, y, z = '0px') => {
        return `translate3d(${x}, ${y}, ${z})`;
    };
    export default {
        name: 'SwitchToggle',
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            name: {
                type: String,
            },
            speed: {
                type: Number,
                default: 300,
            },
            color: {
                type: [String, Object],
                validator (value) {
                    return typeof value === 'object'
                        ? (value.checked || value.unchecked)
                        : typeof value === 'string';
                },
            },

            cssColors: {
                type: Boolean,
                default: false,
            },
            height: {
                type: Number,
                default: 20,
            },
            width: {
                type: Number,
                default: 32,
            },
            margin: {
                type: Number,
                default: 2,
            },
            icon: {
                type: String,
            },
            label: {
                type: String,
            },
            labelPosition: {
                type: String,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            className () {
                var { toggled } = this;

                return ['switch-toggle', { toggled }];
            },
            coreStyle () {
                return {
                    width: px(this.width),
                    height: px(this.height),
                    backgroundColor: this.cssColors
                        ? null
                        : this.colorCurrent,
                    borderRadius: px(Math.round(this.height / 2)),
                };
            },

            iconStyle() {
                return {
                    color: this.cssColors
                        ? null
                        : this.colorCurrent,
                };
            },
            labelStyle() {
                return {
                    order: this.labelPosition === 'right' ? 2 : null,
                    marginRight: this.labelPosition === 'left' ? '10px' : null,
                    marginLeft: this.labelPosition === 'right' ? '10px' : null,
                };
            },

            distance () {
                return px(this.width - this.height + this.margin);
            },
            buttonStyle () {
                const margin = px(this.margin);
                const transform = this.internalState
                    ? translate3d(this.distance, margin)
                    : null;
                return {
                    transform,
                };
            },

            colorChecked () {
                var { color } = this;
                if (typeof color !== 'object') {
                    return color || COLORS.SWITCH_TOGGLE_DEFAULT_COLOR_CHECKED;
                }
                return contains(color, 'checked')
                    ? color.checked
                    : COLORS.SWITCH_TOGGLE_DEFAULT_COLOR_CHECKED;
            },
            colorUnchecked () {
                var { color } = this;
                return contains(color, 'unchecked')
                    ? color.unchecked
                    : COLORS.SWITCH_TOGGLE_DEFAULT_COLOR_UNCHECKED;
            },

            colorCurrent () {
                return this.internalState
                    ? this.colorChecked
                    : this.colorUnchecked;
            },
        },
        watch: {
            value (value) {
                this.internalState = !!value;
            },
        },
        data () {
            return {
                internalState: this.value,
            };
        },
        methods: {
            toggle(event) {
                this.internalState = !this.internalState;
                this.$emit('input', this.internalState);
            },
        },
    };
</script>

<style
    lang="scss"
    scoped
>
.toggle-wrapper {
    display: inline-flex;
    align-items: center;

    .toggle-label {
        margin-right: 10px;
    }

    .cursor-not-allowed {
        cursor: not-allowed;
    }
}

.switch-toggle {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    user-select: none;
    font-size: 10px;
    cursor: pointer;
    margin-bottom: 0;

    .v-switch-input {
        opacity: 0;
        position: absolute;
        width: 1px;
        height: 1px;
    }

    .v-switch-label {
        position: absolute;
        top: 0;
        font-weight: 600;
        color: white;
        z-index: 1;

        &.v-left {
            left: 10px;
        }

        &.v-right {
            right: 10px;
        }
    }

    .v-switch-core {
        display: block;
        position: relative;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        transition: border-color .3s, background-color .3s;
        user-select: none;

        .v-switch-button {
            display: block;
            position: absolute;
            overflow: hidden;
            width: 16px;
            height: 16px;
            transition: transform 300ms ease 0s;
            transform: translate3d(2px, 2px, 0px);
            top: 0;
            left: 0;
            border-radius: 100%;
            background-color: #fff;
            z-index: 2;
            padding: 8%;

            i {
                display: block;
                text-align: center;
            }
        }
    }
}
</style>
